import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import { SERVER_URL } from '../Service/apiConfig';

let socket;

export const getSocket = () => {
  if (!socket) {
    socket = io(SERVER_URL, {
      transports: ['websocket', 'polling'], // fallback to polling if ws fails
    });
  }
  return socket;
};

/**
 * useRealTimeUpdates Hook
 * @param {string} targetEntity - The entity name to listen for (e.g., 'equipment', 'course')
 * @param {function} onUpdateCallback - The function to call when an update occurs (e.g., loadAllData)
 */
export const useRealTimeUpdates = (targetEntity, onUpdateCallback) => {
  const [isConnected, setIsConnected] = useState(false);
  const callbackRef = useRef(onUpdateCallback);

  // Update the ref to the latest callback without triggering the socket effect
  useEffect(() => {
    callbackRef.current = onUpdateCallback;
  }, [onUpdateCallback]);

  useEffect(() => {
    const s = getSocket();

    const onConnect = () => {
      setIsConnected(true);
      console.log('Real-time updates connected');
    };

    const onDisconnect = () => {
      setIsConnected(false);
      console.log('Real-time updates disconnected');
    };

    const onDataChanged = (data) => {
      if (data && data.entity === targetEntity) {
        if (callbackRef.current) {
          callbackRef.current();
        }
      }
    };

    s.on('connect', onConnect);
    s.on('disconnect', onDisconnect);
    s.on('data_changed', onDataChanged);

    // If already connected before this component mounted
    if (s.connected) {
      setIsConnected(true);
    }

    return () => {
      s.off('connect', onConnect);
      s.off('disconnect', onDisconnect);
      s.off('data_changed', onDataChanged);
    };
  }, [targetEntity]); // Only re-run if targetEntity changes

  return { isConnected };
};
